var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('button',{class:_vm.colour,on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', _vm.icon]}}),_vm._v(" "),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }